import { getAllowActionByCurrRole } from "@/utils/get-roles";
const INIT_FILTER_VALUE = {
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  advance_filter: false,
  family_types: [],
  full_name: null,
  member_range: {
    start: null,
    end: null,
  },
  national_id: null,
  problems: [],
  volunteer: localStorage.getItem("volunteerData")
    ? JSON.parse(localStorage.getItem("volunteerData"))
    : null,
  cm_uid: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  //   START: address
  setAddress({ commit }, address) {
    commit("setAddress", address);
  },
  setAmphur({ commit }, amphur) {
    commit("setAmphur", amphur);
  },
  setProvince({ commit }, province) {
    commit("setProvince", province);
  },
  setTumbol({ commit }, tumbol) {
    commit("setProvince", tumbol);
  },
  setVillage({ commit }, village) {
    commit("setVillage", village);
  },
  //   END: address
  //   START: advanceFilter
  setAdvanceFilter({ commit }, boo) {
    commit("setAdvanceFilter", boo);
  },
  toggleAdvanceFilter({ commit }) {
    commit("toggleAdvanceFilter");
  },
  //   END: advanceFilter
  // START: family_type
  appendFamilyType({ commit }, familyType) {
    commit("appendFamilyType", familyType);
  },
  removeFamilyType({ commit }, familyType) {
    commit("removeFamilyType", familyType);
  },
  setFamilyType({ commit }, familyTypes) {
    commit("setFamilyType", familyTypes);
    // if length increate it mean add which last value is the new one
    // if length decreate it mean remove but we need to find new value by ourself
  },
  // END: family_type
  // START: fullName
  setFullName({ commit }, full_name) {
    commit("setFullName", full_name);
  },
  // END: fullName
  //   START: member_range
  setMemberRange({ commit }, member_range) {
    commit("setMemberRange", member_range);
  },
  setMemberRangeStart({ commit }, start) {
    commit("setMemberRangeStart", start);
  },
  setMemberRangeEnd({ commit }, end) {
    commit("setMemberRangeEnd", end);
  },
  // END: member_range
  // START: national_id
  setNationalId({ commit }, national_id) {
    commit("setNationalId", national_id);
  },
  // END: national_id
  // START: problems
  appendProblem({ commit }, problem) {
    commit("appendProblem", problem);
  },
  removeProblem({ commit }, problem) {
    commit("removeProblem", problem);
  },
  setProblem({ commit }, problems) {
    commit("setProblem", problems);
  },
  //   END: problems
  //   START: volunteer
  setVolunteer({ commit }, volunteer) {
    commit("setVolunteer", volunteer);
  },
  // END: volunteer
  // START: cm
  setCM({ commit }, cm_uid) {
    commit("setCM", cm_uid);
  },
  // END: cm
};

// mutations
const mutations = {
  // START: cm
  setCM(state, cm_uid) {
    state.cm_uid = cm_uid;
  },
  // END: cm
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  //   START: address
  setAddress(state, address) {
    state.address = address;
  },
  setProvince(state, province) {
    state.address.province = province;
  },
  setAmphur(state, amphur) {
    state.address.amphur = amphur;
  },
  setTumbol(state, tumbol) {
    state.address.tumbol = tumbol;
  },
  setVillage(state, village) {
    state.address.village = village;
  },
  //   END: address
  //   START: advance_filter
  setAdvanceFilter(state, boo) {
    state.advance_filter = boo;
  },
  toggleAdvanceFilter(state) {
    state.advance_filter = !state.advance_filter;
  },
  //   END: advance_filter
  // START: family_type
  appendFamilyType(state, family_type) {
    state.family_types.push(family_type);
  },
  removeFamilyType(state, family_type) {
    state.family_types = state.family_types.filter(
      (type) => type !== family_type
    );
  },
  setFamilyType(state, family_types) {
    state.family_types = family_types;
  },
  // END: family_type
  // START: fullName
  setFullName(state, full_name) {
    state.full_name = full_name;
  },
  // END: fullName
  //   START: member_range
  setMemberRange(state, { start, end }) {
    state.member_range = { start, end };
  },
  setMemberRangeStart(state, start) {
    state.member_range.start = start;
  },
  setMemberRangeEnd(state, end) {
    state.member_range.end = end;
  },
  // END: member_range
  // START: national_id
  setNationalId(state, national_id) {
    state.national_id = national_id;
  },
  // END: national_id
  // START: problems
  appendProblem(state, problem) {
    state.problems.push(problem);
  },
  removeProblem(state, problem) {
    state.problems = state.problems.filter((type) => type !== problem);
  },
  setProblem(state, problems) {
    state.problems = problems;
  },
  //   END: problems
  //   START: volunteer
  setVolunteer(state, volunteer) {
    state.volunteer = volunteer;
  },
  // END: volunteer
};

// {
//   address: {
//     amphur: null,
//     province: null,
//     tumbol: null,
//     village: null,
//   },
//   advance_filter: false,
//   family_type: [],
//   fullName: null,
//   member_range: {
//     start: null,
//     end: null,
//   },
//   national_id: null,
//   problems: [],
//   volunteer: null,
// };
// getters
const getters = {
  address: (state) => state.address,
  province: (state) => state.address.province,
  amphur: (state) => state.address.amphur,
  tumbol: (state) => state.address.tumbol,
  vaillage: (state) => state.address.village,
  advance_filter: (state) => state.advance_filter,
  family_type: (state) => state.family_type,
  full_name: (state) => state.full_name,
  member_range: (state) => state.member_range,
  national_id: (state) => state.national_id,
  problems: (state) => state.problems,
  volunteer: (state) => state.volunteer,
  getAllFilter: (state) => {
    if (state.advance_filter) return state;
    const commonFilter = {
      ...state,
      full_name: null,
      national_id: null,
      family_types: [],
      member_range: {
        start: null,
        end: null,
      },
      problems: [],
      volunteer: null,
    };
    if (localStorage.getItem("volunteerData")) {
      commonFilter.volunteer = JSON.parse(
        localStorage.getItem("volunteerData")
      );
    }
    return commonFilter;
  },
  getCommonFilter: (state) => {
    const commonFilter = {
      address: {
        amphur: state.address.amphur,
        province: state.address.province,
        tumbol: state.address.tumbol,
        village: state.address.village,
      },
    };
    return commonFilter;
  },
  getFilterSummaryArray: (state, getters, rootState, rootGetters) => {
    let prepareState = { ...state };
    if (!state.advance_filter)
      prepareState = {
        ...prepareState,
        full_name: null,
        national_id: null,
        family_types: [],
        member_range: {
          start: null,
          end: null,
        },
        problems: [],
        volunteer: null,
      };
    let result = [];
    // national_id
    if (prepareState.national_id)
      result.push({
        title: "เลขบัตรประชาชน",
        text: prepareState.national_id,
      });
    // full_name
    if (prepareState.full_name)
      result.push({
        title: "ชื่อ - นามสกุล",
        text: prepareState.full_name,
      });
    // address
    if (prepareState.address.province || getAllowActionByCurrRole("default-provinceCode-search"))
      result.push({
        title: "จังหวัด",
        text: prepareState.address.province ? prepareState.address.province.province_name : rootGetters["userAuth/getTokenParsed"]['provinceName']
        ,
      });
    if (prepareState.address.amphur)
      result.push({
        title: "อำเภอ/เขต",
        text: prepareState.address.amphur.amphur_name,
      });
    if (prepareState.address.tumbol)
      result.push({
        title: "ตำบล/แขวง",
        text: prepareState.address.tumbol.tumbol_name,
      });
    if (prepareState.address.village)
      result.push({
        title: "หมู่บ้าน",
        text: prepareState.address.village.village_name,
      });
    if (prepareState.family_types.length > 0)
      result.push({
        title: "ลักษณะครอบครัว",
        text: prepareState.family_types.map((item) => item.desc).join(", "),
      });
    if (prepareState.problems.length > 0)
      result.push({
        title: "สภาพปัญหา",
        text: prepareState.problems.join(", "),
      });

    if (
      typeof prepareState.member_range.start === "number" &&
      prepareState.member_range.end
    ) {
      result.push({
        title: "จำนวนสมาชิก",
        text: `${prepareState.member_range.start} - ${prepareState.member_range.end}`,
      });
    } else if (prepareState.member_range.start) {
      result.push({
        title: "จำนวนสมาชิก",
        text: `${prepareState.member_range.start} ขึ้นไป`,
      });
    } else if (prepareState.member_range.end) {
      result.push({
        title: "จำนวนสมาชิก",
        text: `น้อยกว่า ${prepareState.member_range.end}`,
      });
    }
    if (prepareState.volunteer) {
      result.push({
        title: "อพม.",
        text: `${prepareState.volunteer.title}${prepareState.volunteer.name} ${prepareState.volunteer.surname}`,
      });
    }
    return result;
  },
  getFilterForApi: (state, getters, rootState, rootGetters) => {
    const result = {};
    // if (state.address.province)
    //action include default-provinceCode-search send provCode for default
    if (
      getAllowActionByCurrRole("default-provinceCode-search") ||
      state.address.province
    ) {
      result.prov = state.address.province
        ? state.address.province._id.province_ID.toString()
        : rootGetters["userAuth/getTokenParsed"]["provinceCode"].toString();
    }
    if (state.address.amphur)
      result.amp = state.address.amphur._id.amphur_ID.toString();
    if (state.address.tumbol)
      result.tam = state.address.tumbol._id.tumbol_ID.toString();
    if (state.address.village)
      result.vil = state.address.village._id.village_ID.toString();

    if (state.advance_filter) {
      if (state.full_name) result.head_name = state.full_name;
      if (state.national_id) result.famhead_nid = state.national_id;
      // fam_type
      if (state.family_types.length > 0)
        result.fam_type = state.family_types.map((item) => item.code);
      if (state.problems.length > 0) {
        for (const index in state.problems) {
          const value = state.problems[index];
          if (value === "ปัญหาด้านสุขภาพ") result.prob_health = 1;
          if (value === "ปัญหาด้านครัวเรือน") result.prob_family = 1;
          if (value === "ปัญหาด้านการศึกษา") result.prob_education = 1;
          if (value === "ปัญหาด้านการเงิน") result.prob_occupation = 1;
          if (value === "ปัญหาด้านการเข้าถึงสิทธิ")
            result.prob_accessibility = 1;
        }
      }
      if (state.member_range.start || state.member_range.end) {
        result.member_cnt_range = `[${
          state.member_range.start ? state.member_range.start : ""
        },${state.member_range.end ? state.member_range.end : ""}]`;
      }
      if (state.volunteer) result.volunteer_id = state.volunteer.national_id;
    }
    //if vt role send volunteer for default
    if (rootGetters["userAuth/getUserRoleCode"] === "vt") {
      if (state.volunteer) result.volunteer_id = state.volunteer.national_id;
    }
    // if (state.cm_uid) result.cm_uid = state.cm_uid;
    //if action include default-cm_uid-search send cm_uid for default
    if (getAllowActionByCurrRole("default-cm_uid-search")) {
      result.cm_uid = state.cm_uid
        ? state.cm_uid
        : rootGetters["userAuth/getUsername"];
    }
    return result;
  },

  // {
  //   // require
  //   "start": "1",
  //   "draw": "1",
  //   "length": "10",
  //   "sorter": [
  //     {
  //       "field": "_id",
  //       "dir": "asc"
  //     }
  //   ],
  //   "prov": "70", ✅
  //   //   not require
  //   "amp": "222", // UI มีแต่ request ไม่มี ✅
  //   "tam": "1234", // UI มีแต่ request ไม่มี ✅
  //   "village": "12345", //UI มีแต่ request ไม่มี ✅
  //   "fam_head": "1234567890123", //เลขบัครประชาชนของหัวหน้าครอบครัว มีใน ui แต่ไม่มีใน request✅
  //   "head_name": "สมโรจ สมหมาย",✅
  //   "hh_type": "string", // ไม่มีใน ui ✅
  //   "house_type": "string", // ไม่มีใน ui ✅
  //   "fam_type": ["ครอบครัวเดี่ยว", "ครอบครัวข้ามรุ่น"], //มีใน ui แต่ไม่มีใน request ✅
  //   "house_solid": true, // ไม่มีใน ui ✅
  //   "volunteer_id": "string",
  //   "prob_health": true,// เปลี่ยน 0 1 เป็น true false แต่ไม่ต้องก็ได้ ✅
  //   "prob_education": true, ✅
  //   "prob_occupation": true, ✅
  //   "prob_family": true, ✅
  //   "prob_housing": true, // ไม่ได้ใช้ ✅
  //   "prob_violence": true, // ไม่ได้ใช้ ✅
  //   "prob_human_trafficking": true, // ไม่ได้ใช้ ✅
  //   "prob_accessibility": true, ✅
  //   "prob_others": true, // ไม่ได้ใช้ ✅
  //   "family_cnt_range": "[1,1]", // ไม่มีใน ui ✅
  //   "member_cnt_range": "[1,1]" ✅
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
